import React from 'react';
import { ManageAttributesVM } from './manage-attributes.viewmodel';
import { makeConnect } from '../../../infrastructure/components/mobx-extensions';

export const ManageAttributesContext = React.createContext<ManageAttributesVM>(null);

export const connectedManageAttributesVM = makeConnect(ManageAttributesContext);
